import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { TrendingUp } from 'lucide-react';
import { servicePricing } from '../../mockData';

const DigitalMarketing = () => {
  const features = [
    {
      title: "SEO Optimization",
      description: "Rank higher in Google with on-page and off-page SEO strategies"
    },
    {
      title: "Social Media Management",
      description: "Engage your audience across Facebook, Instagram, LinkedIn, and Twitter"
    },
    {
      title: "Content Marketing",
      description: "Create valuable content that attracts and converts your ideal customers"
    },
    {
      title: "Paid Advertising",
      description: "Google Ads, Facebook Ads, and other PPC campaigns with ROI tracking"
    },
    {
      title: "Email Campaigns",
      description: "Automated email sequences that nurture leads and drive sales"
    },
    {
      title: "Analytics & Reporting",
      description: "Detailed reports showing what's working and where to improve"
    }
  ];

  const benefits = [
    {
      title: "Increased Visibility",
      description: "Reach more potential customers through search engines and social media"
    },
    {
      title: "Qualified Leads",
      description: "Attract people who are actively looking for your products or services"
    },
    {
      title: "Measurable Results",
      description: "Track every click, conversion, and dollar spent with detailed analytics"
    },
    {
      title: "Competitive Edge",
      description: "Outperform competitors who aren't investing in digital marketing"
    }
  ];

  const process = [
    {
      title: "Market Research",
      description: "Analyze your industry, competitors, and target audience"
    },
    {
      title: "Strategy Development",
      description: "Create a custom marketing plan based on your goals and budget"
    },
    {
      title: "Campaign Execution",
      description: "Launch and manage campaigns across multiple channels"
    },
    {
      title: "Optimization & Scaling",
      description: "Continuously improve performance and scale what works"
    }
  ];

  return (
    <ServicePageTemplate
      title="Digital Marketing"
      subtitle="Grow Your Business Online"
      description="Data-driven marketing strategies that increase visibility, generate leads, and drive sales. From SEO to social media, we handle it all."
      features={features}
      benefits={benefits}
      pricing={servicePricing.digitalMarketing}
      icon={TrendingUp}
      bgColor="#ffe03d"
      process={process}
    />
  );
};

export default DigitalMarketing;